export default __webpack_public_path__ + "static/media/gallery_10.54ca3c34.jpg";